import { getCsrfValue } from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "../../../utils/url/urlResolver";

type FavouriteData = {
  assetID: string;
  addToFavourite: boolean;
};

const apiUrl = resolveApiUrl("/media-library/favourite");

export async function addToFavourites(data: FavouriteData) {
  const response = await fetch(apiUrl, {
    body: JSON.stringify(data),
    method: "POST",
    cache: "no-cache",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });

  if (!response.ok) {
    throw new Error(`Error status: ${response.status}`);
  }

  return response.status;
}
